import React, { Component } from 'react';
// import './App.css';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
import MoblieMenu from "./mobilemenu";
import Banner from './banner';
import TextSlider from './textslide';
//import './style.css';
import NavMenu from './navmenu';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            pagecount: 1,
            playerid: null,
            user_id: null,
            point: null,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
        }
        this.handleClick = this.handleClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.hideAlert = this.hideAlert.bind(this);

    }
    handlePageChange(pageNumber) {
        //////console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: 0,
                    page: pageNumber
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
    }

    handleClick = async (e) => {
        this.setState({
            activePage: 1,
            isActive: true,
            activeTab: 0
        });
        instance.get("/api/v1/rewardlist", {
            params: {
                Cat_ID: e.target.id,
                page: 1
            }
        })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
        this.setState({
            isActive: false
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }




    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem('auth_token');
        const search = window.location.href;
        const params = new URLSearchParams(search);
        this.checklogin();
        await instance.post("/api/v1/tabgamelist", {
            state: "5",
            System: Systems,
        })
            .then((res) => {
                if (res.data.status === 200) {
                    this.setState({
                        categorylist: res.data.message
                    });
                }
                else {
                    //  this.CheckThisGoalError();
                }
            });

    }

    render() {
        return (
            <>
                <div
                    className="standard-normal-font-size body-content-container"
                    data-radium="true"
                >
                    <div className="providerLandingIndexContainer sports-container">
                        <div className="_productBannerContainer_1ma75_1 product-banner-container">
                            <div className="slick-slider slider slick-initialized">
                                <div className="slick-list">
                                    <div
                                        className="slick-track"
                                        style={{
                                            width: 1064,
                                            opacity: 1,
                                            transform: "translate3d(0px, 0px, 0px)"
                                        }}
                                    >
                                        <div
                                            data-index={0}
                                            className="slick-slide slick-active slick-current"
                                            tabIndex={-1}
                                            aria-hidden="false"
                                            style={{ outline: "none", width: 1064 }}
                                        >
                                            <div>
                                                <div
                                                    className="_productBannerWrapper_1ma75_1 top top-provider-img"
                                                    tabIndex={-1}
                                                    style={{ width: "100%", display: "inline-block" }}
                                                >
                                                    <picture>
                                                        <source
                                                            type="image/webp"
                                                            srcSet="https://baryon.million-edge.online/public/html/banner/compress/banner20250122035326766.webp"
                                                        />
                                                        <img
                                                            src="https://baryon.million-edge.online/public/html/cms/banner20250122035326766.jpg"
                                                            className="_productBanner_1ma75_1 provider-banner"
                                                            alt="banner-img"
                                                        />
                                                    </picture>
                                                    <div className="_content_1ma75_25 top-provider-content ">
                                                        <p className="_title_1ma75_48 provider-type">Sportsbook</p>
                                                        <div className="_desc_1ma75_58 provider-desc" />
                                                    </div>
                                                    <div className="bk8-logo-container">
                                                        <div className="logo-img" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mid" id="provider-box">
                            <ul className="provider-box">
                                <li
                                    className="tab-header active"
                                    data-provider-name="BTI"
                                    data-provider-code="BTI"
                                >
                                    <p className="float-dot hot-provider">ฮอต</p>
                                    <div className="tab-inner">
                                        <svg
                                            className="hI3cB4aTf3d7f632"
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 76.442 38.92"
                                            xmlSpace="preserve"
                                        >
                                            <title>BTI</title>
                                            <style
                                                type="text/css"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        ".hI3cB4aTf3d7f632 .st0{fill:#034EA2;} .hI3cB4aTf3d7f632 .st1{fill:#FDB913;} "
                                                }}
                                            />
                                            <g>
                                                <path
                                                    className="st0"
                                                    d="M21.92551,15.55271c0.80231-3.21103-1.12866-7.26898-9.5207-7.4876
		C7.25116,7.93085,3.29779,8.63287,3.29779,8.63287l-3.29797,23.54191c0,0,3.86067,0.58858,8.23481,0.58858
		c5.61728,0,11.7049-0.86744,13.44126-6.43749c0.62241-1.99662,0.30627-4.14652-1.26599-5.54817
		c-1.07954-0.96241-2.2601-1.24231-2.2601-1.24231S21.18602,18.51231,21.92551,15.55271z M10.1133,26.82229
		c-0.62387,0-1.5736-0.0555-1.5736-0.0555l0.67872-4.8411c0,0,0.83837-0.08947,1.66129-0.08947
		c2.14931,0,3.46932,0.79735,3.52756,2.21856C14.40727,25.78505,12.9255,26.82229,10.1133,26.82229z M14.2753,16.47676
		c-0.81554,0.81706-2.28373,0.9002-3.02557,0.9002c-0.59232,0-1.38719-0.05065-1.38719-0.05065l0.63262-4.51889
		c0,0,0.8409-0.03687,1.36923-0.03687c1.92811,0,2.92775,0.73436,3.07252,1.89755
		C15.01798,15.31941,14.70051,16.05094,14.2753,16.47676z"
                                                />
                                                <path
                                                    className="st0"
                                                    d="M41.36535,8.73628c-1.0084,3.38192-4.82676,5.66166-8.7833,5.80401l-0.91786,6.55112
		c0.16684,0.00698,0.34097,0.01259,0.52183,0.01259l0.14029-0.00089c8.12376-0.11315,15.31945-5.34421,16.32737-12.36685h-7.28833
		V8.73628z"
                                                />
                                                <polygon
                                                    className="st0"
                                                    points="25.83935,8.73628 22.57477,31.99266 29.43293,31.99266 32.69149,8.73628 	"
                                                />
                                                <path
                                                    className="st1"
                                                    d="M69.17327,14.01083c0.58447-3.85237-1.70071-6.79216-9.33421-7.04308
		c-5.50394-0.18094-9.79288,1.56786-10.74352,6.29274c-0.58181,2.89173,0.63229,5.00601,3.16802,6.17787
		c-2.88993,0.99545-4.93266,2.94807-5.57139,6.29146c-0.9973,5.22009,3.18807,8.12643,9.95187,8.12643
		c6.81881,0,11.09842-2.67019,11.76104-7.27471c0.44073-3.0625-0.65916-5.75062-4.18094-7.09061
		C67.02061,18.4198,68.79105,16.53,69.17327,14.01083z M57.3218,14.20819c0.16894-1.52115,0.90063-2.71245,2.12489-2.71245
		c1.14625,0,1.61852,1.21721,1.4496,2.73836s-0.96598,2.7413-2.0931,2.7413C57.73738,16.9754,57.1529,15.72927,57.3218,14.20819z
		 M59.61976,25.18002c-0.19902,1.91052-1.1437,3.44305-2.48117,3.44305c-1.26474,0-1.95948-1.56514-1.76045-3.47566
		c0.19901-1.91052,1.06615-3.40681,2.51889-3.40681C59.25723,21.74059,59.81876,23.26943,59.61976,25.18002z"
                                                />
                                                <path
                                                    className="st0"
                                                    d="M69.5688,8.68095c2.64318,2.94932,4.24162,6.76924,4.24162,10.94578
		c0,9.33409-7.967,16.90087-17.79477,16.90087c-4.11787,0-7.906-1.33213-10.92133-3.56248
		c3.26399,3.64205,8.12281,5.95504,13.55315,5.95504c9.82771,0,17.7947-7.56677,17.7947-16.90086
		C76.44218,16.59631,73.74984,11.7735,69.5688,8.68095z"
                                                />
                                                <path
                                                    className="st1"
                                                    d="M63.91852,2.87018l-2.97415-2.87034l-3.38903,2.71349l-3.35071-1.64159l-0.9163,4.82824
		c1.69149-0.5068,3.49134-0.78152,5.35913-0.78152c3.61238,0,6.97119,1.02523,9.77754,2.7819l0.83379-6.60087L63.91852,2.87018z"
                                                />
                                                <path
                                                    className="st0"
                                                    d="M43.15125,18.39448c-1.95874,1.37578-4.27171,2.39429-6.79053,2.94404
		c0.30679,0.40529,0.67683,0.96921,0.87137,1.47724c0.51339,1.34048,0.58214,2.13415,0.2878,4.38853l-0.65818,4.7693h7.4035
		c0.24431-1.64723,0.66151-5.04693,0.77499-6.13378c0.1584-1.51731,0.28685-3.26249-0.65348-5.28142
		C44.08544,19.91191,43.5323,18.93137,43.15125,18.39448z"
                                                />
                                            </g>
                                        </svg>
                                        <span>BK8 Sports</span>
                                    </div>
                                </li>
                                <li
                                    className="tab-header false"
                                    data-provider-name="IBC"
                                    data-provider-code="IBC"
                                >
                                    <div className="tab-inner">
                                        <svg
                                            className="hc0I6Cc0Ba6ed888"
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 90 90"
                                            xmlSpace="preserve"
                                        >
                                            <title>IBC</title>
                                            <style
                                                type="text/css"
                                                dangerouslySetInnerHTML={{
                                                    __html: ".hc0I6Cc0Ba6ed888 .st0{fill:url(#SVGID_1_);} "
                                                }}
                                            />
                                            <g>
                                                <radialGradient
                                                    id="SVGID_1_"
                                                    cx="56.20116"
                                                    cy="18.11583"
                                                    r="70.47055"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop
                                                        offset={0}
                                                        style={{ stopColor: "rgb(180, 180, 180)" }}
                                                    />
                                                    <stop offset={1} style={{ stopColor: "rgb(1, 1, 1)" }} />
                                                </radialGradient>
                                                <path
                                                    className="st0"
                                                    d="M15.09694,59.25006c1.62338,3.57595,3.62044,6.98436,5.95443,10.15911
		c-0.87635-2.1851-1.61268-4.42571-2.21183-6.69966C17.53855,61.62229,16.29081,60.4668,15.09694,59.25006z"
                                                />
                                                <radialGradient
                                                    id="SVGID_00000101817911661187301120000001151868817255134596_"
                                                    cx="56.20116"
                                                    cy="18.11583"
                                                    r="70.47055"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop
                                                        offset={0}
                                                        style={{ stopColor: "rgb(180, 180, 180)" }}
                                                    />
                                                    <stop offset={1} style={{ stopColor: "rgb(1, 1, 1)" }} />
                                                </radialGradient>
                                                <path
                                                    d="M41.93806,45.9109h-4.0337v3.74813h4.0337
		c1.03502,0,1.87408-0.83904,1.87408-1.87407C43.81214,46.74995,42.97308,45.9109,41.93806,45.9109z"
                                                    style={{
                                                        fill:
                                                            'url("#SVGID_00000101817911661187301120000001151868817255134596_")'
                                                    }}
                                                />
                                                <radialGradient
                                                    id="SVGID_00000161622624279651908260000007499026836383122585_"
                                                    cx="56.20116"
                                                    cy="18.11583"
                                                    r="70.47055"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop
                                                        offset={0}
                                                        style={{ stopColor: "rgb(180, 180, 180)" }}
                                                    />
                                                    <stop offset={1} style={{ stopColor: "rgb(1, 1, 1)" }} />
                                                </radialGradient>
                                                <path
                                                    d="M18.5138,61.41061
		c-1.01804-4.26678-1.54727-8.63744-1.54727-12.97953c0-2.69883,0.20146-5.37735,0.58641-8.01831
		c-2.65629-4.2673-4.7384-8.87145-6.1644-13.65696c-0.59795,3.25269-0.9062,6.57082-0.9062,10.01381
		c0,7.36699,1.44569,14.40137,4.06063,20.84081C15.80105,58.95008,17.12693,60.21778,18.5138,61.41061z"
                                                    style={{
                                                        fill:
                                                            'url("#SVGID_00000161622624279651908260000007499026836383122585_")'
                                                    }}
                                                />
                                                <radialGradient
                                                    id="SVGID_00000137851961526358153230000017204111728693995417_"
                                                    cx="56.20116"
                                                    cy="18.11583"
                                                    r="70.47055"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop
                                                        offset={0}
                                                        style={{ stopColor: "rgb(180, 180, 180)" }}
                                                    />
                                                    <stop offset={1} style={{ stopColor: "rgb(1, 1, 1)" }} />
                                                </radialGradient>
                                                <path
                                                    d="M19.94147,63.6032
		c0.81246,2.84743,1.84872,5.63504,3.10241,8.31966c5.46695,2.17026,11.20122,3.31819,16.59448,3.31819
		c2.47992,0,5.04876-0.26656,7.63754-0.77287c-0.39328-0.03613-0.78656-0.07306-1.17992-0.11812
		C36.33975,73.2331,27.36202,69.46415,19.94147,63.6032z"
                                                    style={{
                                                        fill:
                                                            'url("#SVGID_00000137851961526358153230000017204111728693995417_")'
                                                    }}
                                                />
                                                <radialGradient
                                                    id="SVGID_00000170982162218324928500000017041162196983797378_"
                                                    cx="56.20116"
                                                    cy="18.11583"
                                                    r="70.47055"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop
                                                        offset={0}
                                                        style={{ stopColor: "rgb(180, 180, 180)" }}
                                                    />
                                                    <stop offset={1} style={{ stopColor: "rgb(1, 1, 1)" }} />
                                                </radialGradient>
                                                <path
                                                    d="M44.99999,5
		C22.90861,5,5.00001,22.9086,5.00001,44.99998S22.90861,85,44.99999,85s40-17.90862,40-40.00002S67.09138,5,44.99999,5z
		 M73.88922,53.96841h-4.83797L63.4929,43.91042l-11.48839,4.10229l9.30654-16.62337L73.88922,53.96841z M59.80547,14.75213
		l10.96346,20.05419h-4.83797l-4.916-8.89562l-8.89564,2.80914L59.80547,14.75213z M50.48065,31.84112l6.00845-1.83374
		l-2.61406,4.79895h-4.83797L50.48065,31.84112z M50.48065,51.0032l6.00845-1.83376l-2.61406,4.79896h-4.83797L50.48065,51.0032z
		 M48.26398,47.6425c0,3.49372-2.83221,6.32591-6.32592,6.32591h-4.0337h-1.64879h-2.66769V38.44298h4.31649v3.09216h4.0337
		c1.03502,0,1.87408-0.83906,1.87408-1.87407c0-0.60765-0.29046-1.14611-0.7387-1.48855
		c1.53002-0.37994,2.90871-1.14532,4.02794-2.18689c0.73133,1.03192,1.16261,2.29148,1.16261,3.65253
		c0,1.51974-0.53634,2.914-1.4295,4.00475C47.72615,44.7332,48.26398,46.12417,48.26398,47.6425z M45.6287,14.53323v4.56694h-7.152
		c-1.04445,0-1.89113,0.84668-1.89113,1.89112s0.84668,1.89113,1.89113,1.89113h2.3897c3.53395,0,6.3988,2.86482,6.3988,6.39878
		s-2.86484,6.39878-6.3988,6.39878h-7.152v-4.56692h7.152c1.04443,0,1.89113-0.84668,1.89113-1.89113
		c0-1.04444-0.8467-1.89112-1.89113-1.89112h-2.3897c-3.53395,0-6.39878-2.86482-6.39878-6.39878
		c0-3.53397,2.86482-6.3988,6.39878-6.3988H45.6287z M76.4991,67.31039l-1.1207,1.60365
		c-7.405,3.80167-15.04123,5.77845-23.29539,5.77845c-0.62986,0-1.26059-0.01555-1.89164-0.03835
		c-3.56664,0.92343-7.14168,1.41584-10.55301,1.41584c-5.04733,0-10.38351-0.98664-15.52976-2.85719
		c2.98094,3.40211,6.37745,6.46524,10.13302,9.08875l-1.95392-0.31773c-2.55949-1.78794-4.90722-3.75111-7.04982-5.8619
		c0.71138,1.23084,1.46704,2.43298,2.26773,3.60213c-6.40045-3.22692-11.79345-8.17065-15.57003-14.22231
		c2.64478,2.08829,5.53333,3.8791,8.61036,5.33444c-3.31421-4.28773-5.91015-9.03067-7.76405-14.10641
		c-2.10828-2.4523-4.0077-5.12069-5.66686-7.98635c-0.01567-0.02693-0.03182-0.05353-0.04746-0.08049
		c-0.3165-0.54885-0.62701-1.10258-0.92573-1.66562c-0.03525-0.67719-0.05311-1.35891-0.05311-2.04472
		c0-7.3896,2.09007-14.37989,5.683-20.27073l0.0501-0.09422c0.00059,0.00211,0.00125,0.00422,0.00184,0.00632
		c0.00128-0.00208,0.00245-0.00425,0.00373-0.00632c-0.00083,0.00369-0.00152,0.0074-0.00234,0.0111
		c1.38886,4.95629,3.42811,9.66889,6.01825,14.02248c2.18367-12.18696,8.38496-23.4485,17.74999-31.85461l1.42345-0.1494
		c-9.5046,8.53131-16.28195,20.55572-18.46526,33.16693c8.80917,14.05084,23.4579,24.12238,40.56091,26.08055
		c1.8868,0.21593,4.62786,0.33176,7.36038,0.31469c0.1592-0.1132,0.31902-0.22562,0.47662-0.3406l0.01025,0.01404
		c8.41232-6.46616,14.46973-15.85154,16.63862-26.62833c0.27792,1.8723,0.42195,3.78768,0.42195,5.73606
		c0,7.37078-2.06098,14.26924-5.63676,20.14945c-3.57442,0.84691-7.26774,1.34434-11.03623,1.4632
		c-4.24781,3.08411-9.07558,5.52184-14.01826,7.15547C61.3468,73.31877,69.54344,70.88128,76.4991,67.31039z"
                                                    style={{
                                                        fill:
                                                            'url("#SVGID_00000170982162218324928500000017041162196983797378_")'
                                                    }}
                                                />
                                                <radialGradient
                                                    id="SVGID_00000139294804697555495990000013693866307220030393_"
                                                    cx="56.20116"
                                                    cy="18.11583"
                                                    r="70.47055"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop
                                                        offset={0}
                                                        style={{ stopColor: "rgb(180, 180, 180)" }}
                                                    />
                                                    <stop offset={1} style={{ stopColor: "rgb(1, 1, 1)" }} />
                                                </radialGradient>
                                                <path
                                                    d="M28.80953,53.50087
		c-4.08008-3.46878-7.62028-7.51469-10.53018-11.95103c-0.31606,2.28487-0.48389,4.58404-0.48389,6.88124
		c0,4.6498,0.61399,9.33349,1.79615,13.88262c7.51927,6.11884,16.70879,10.08055,26.59881,11.21284
		c1.33611,0.15292,2.69038,0.23624,4.055,0.25813c5.21985-1.38258,10.41415-3.70577,15.02494-6.77693
		c-1.68235-0.01272-4.14396-0.07825-6.2524-0.31955C47.63726,65.38517,37.46669,60.86056,28.80953,53.50087z"
                                                    style={{
                                                        fill:
                                                            'url("#SVGID_00000139294804697555495990000013693866307220030393_")'
                                                    }}
                                                />
                                            </g>
                                        </svg>
                                        <span>Saba Sports</span>
                                    </div>
                                </li>
                                <li
                                    className="tab-header false"
                                    data-provider-name="CMD368"
                                    data-provider-code="CMD"
                                >
                                    <div className="tab-inner">
                                        <svg
                                            className="hfaM5a8D53dC161b"
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 76.442 51.966"
                                            xmlSpace="preserve"
                                        >
                                            <title>CMD</title>
                                            <style
                                                type="text/css"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        ".hfaM5a8D53dC161b .st0{fill:url(#SVGID_1_);} .hfaM5a8D53dC161b .st1{fill:url(#SVGID_2_);} .hfaM5a8D53dC161b .st2{fill:url(#SVGID_3_);} .hfaM5a8D53dC161b .st3{fill:url(#SVGID_4_);} .hfaM5a8D53dC161b .st4{fill:url(#SVGID_5_);} .hfaM5a8D53dC161b .st5{fill:url(#SVGID_6_);} "
                                                }}
                                            />
                                            <g>
                                                <g>
                                                    <g>
                                                        <radialGradient
                                                            id="SVGID_1_"
                                                            cx="104.74067"
                                                            cy="135.97427"
                                                            r="13.5906"
                                                            gradientTransform="matrix(0.9745 0 0 0.9222 -61.64477 -112.67091)"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop
                                                                offset={0}
                                                                style={{ stopColor: "rgb(69, 148, 198)" }}
                                                            />
                                                            <stop
                                                                offset={1}
                                                                style={{ stopColor: "rgb(3, 113, 178)" }}
                                                            />
                                                        </radialGradient>
                                                        <polygon
                                                            className="st1"
                                                            points="34.87096,0.02331 40.54411,17.49359 40.6107,17.49359 45.97882,0.02331 53.48912,0.02331 
				53.48912,25.42581 48.4925,25.42581 48.4925,7.42507 48.42554,7.42507 42.4795,25.42581 38.36757,25.42581 32.42386,7.60228 
				32.35911,7.60228 32.35911,25.42581 27.36092,25.42581 27.36092,0.02331 			"
                                                        />
                                                    </g>
                                                    <g>
                                                        <g>
                                                            <radialGradient
                                                                id="SVGID_2_"
                                                                cx="97.83921"
                                                                cy="135.97427"
                                                                r="12.47088"
                                                                gradientTransform="matrix(0.9322 0 0 0.9222 -25.03283 -112.67091)"
                                                                gradientUnits="userSpaceOnUse"
                                                            >
                                                                <stop
                                                                    offset={0}
                                                                    style={{ stopColor: "rgb(69, 148, 198)" }}
                                                                />
                                                                <stop
                                                                    offset={1}
                                                                    style={{ stopColor: "rgb(3, 113, 178)" }}
                                                                />
                                                            </radialGradient>
                                                            <path
                                                                className="st1"
                                                                d="M65.91055,0.02331c1.4941,0,2.8874,0.26307,4.17498,0.7836
					c1.29027,0.52139,2.40588,1.30584,3.35029,2.34946c0.94194,1.04388,1.67709,2.34801,2.21013,3.91252
					c0.5291,1.56612,0.79623,3.40462,0.79623,5.51382c0,1.85053-0.21783,3.55779-0.65128,5.12429
					c-0.43295,1.56426-1.09035,2.91622-1.96507,4.05379c-0.87817,1.14016-1.97171,2.03463-3.28405,2.68726
					c-1.30893,0.65261-2.85332,0.97777-4.63123,0.97777H55.90359V0.02331H65.91055z M65.55301,20.73067
					c0.73675,0,1.45473-0.12954,2.14673-0.39273c0.69322-0.2605,1.31039-0.69297,1.853-1.29873
					c0.54037-0.60345,0.97334-1.39159,1.30081-2.36494c0.32404-0.97161,0.48373-2.15726,0.48373-3.55744
					c0-1.28205-0.11015-2.43788-0.34073-3.46998c-0.22567-1.03061-0.59755-1.91383-1.12051-2.6491
					c-0.52101-0.73504-1.20883-1.29775-2.06493-1.689c-0.85511-0.39137-1.91162-0.58798-3.16866-0.58798h-3.63815v16.00989H65.55301
					z"
                                                            />
                                                        </g>
                                                    </g>
                                                    <g>
                                                        <radialGradient
                                                            id="SVGID_3_"
                                                            cx="40.23684"
                                                            cy="135.96283"
                                                            r="13.58642"
                                                            gradientTransform="matrix(0.9322 0 0 0.9222 -25.03283 -112.67091)"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop
                                                                offset={0}
                                                                style={{ stopColor: "rgb(69, 148, 198)" }}
                                                            />
                                                            <stop
                                                                offset={1}
                                                                style={{ stopColor: "rgb(3, 113, 178)" }}
                                                            />
                                                        </radialGradient>
                                                        <path
                                                            className="st2"
                                                            d="M21.17263,0.00025h-0.47145c0.04182,0.01434,0.08475,0.02771,0.12597,0.0428
				c0.03175,0.01178,0.05873,0.02539,0.08965,0.03728c1.13795,0.4457,1.74554,1.05676,1.81349,1.83534
				c0.03949,0.46545-0.13087,0.98156-0.50285,1.54587c-0.19417,0.29424-0.44339,0.83316-0.74891,1.15412
				c0-1.95319-3.70989-2.35401-5.03967-2.23774c-2.84473,0.25377-5.55221,1.0955-7.43547,3.86763
				c-1.88256,2.76892-2.19873,5.41717-1.89188,8.86605c0.20055,2.20071,0.99628,3.88652,2.37855,5.05928
				c1.23739,1.04669,2.55428,1.54981,4.41426,1.50957c0.33471,0.00859-0.49097-0.00256-0.13381-0.03557
				c1.40825-0.13232,2.74734-0.51403,4.01957-1.13659c1.88806-0.92366,3.62785-2.38247,5.21665-4.38545
				c0.24897,0.44118,0.38363,0.79724,0.4083,1.06498c0.01005,0.11921,0.00686,0.2394-0.00271,0.35997
				c-0.09738,1.22795-1.21433,2.5262-3.35715,3.89483c-1.81961,1.16186-3.7386,1.81791-5.66873,2.34997
				c-2.66834,0.73479-5.76916,0.23169-5.76916,0.23169c-1.08387-0.28284-2.28385-0.97593-3.12696-1.62879
				c-1.77435-1.37403-2.53833-3.3888-2.76488-6.04465c-0.35997-4.19277,0.81806-7.9349,3.52225-11.22558
				c2.02787-2.4639,4.46492-4.08862,7.28792-4.9202L13.4904,0.19306c0.22137-0.06084,0.4354-0.11333,0.64894-0.16423
				c0.03703-0.00995,0.07297-0.01977,0.11025-0.02858H3.77632c-2.07487,0-3.7765,1.68287-3.7765,3.7397v17.94837
				c0,2.05731,1.70163,3.73945,3.7765,3.73945h17.39631c2.07916,0,3.77944-1.68214,3.77944-3.73945V3.73995
				C24.95207,1.68312,23.2518,0.00025,21.17263,0.00025z"
                                                        />
                                                    </g>
                                                </g>
                                                <g>
                                                    <radialGradient
                                                        id="SVGID_4_"
                                                        cx="67.92238"
                                                        cy="166.4474"
                                                        r="10.59101"
                                                        gradientTransform="matrix(0.9322 0 0 0.9222 -25.03283 -112.67091)"
                                                        gradientUnits="userSpaceOnUse"
                                                    >
                                                        <stop
                                                            offset={0}
                                                            style={{ stopColor: "rgb(69, 148, 198)" }}
                                                        />
                                                        <stop
                                                            offset={1}
                                                            style={{ stopColor: "rgb(3, 113, 178)" }}
                                                        />
                                                    </radialGradient>
                                                    <path
                                                        className="st3"
                                                        d="M38.06536,37.51595c0.25021-0.06169,0.50041-0.11283,0.7506-0.15453
			c0.25021-0.0411,0.51071-0.06194,0.78201-0.06194c1.04205,0,1.99085,0.1857,2.84596,0.55695
			c0.85461,0.37138,1.58413,0.87706,2.18953,1.51618c0.60393,0.63949,1.07342,1.39759,1.40704,2.27416
			c0.3331,0.87706,0.50041,1.80994,0.50041,2.80022c0,1.13451-0.21391,2.16108-0.64123,3.07873
			c-0.42731,0.91816-1.0116,1.70716-1.75094,2.3669c-0.7408,0.66034-1.6165,1.17093-2.62715,1.53163
			c-1.0116,0.36073-2.09092,0.54151-3.23695,0.54151c-1.16811,0-2.25233-0.18078-3.25265-0.54151
			c-1.00082-0.3607-1.87164-0.87129-2.61145-1.53163c-0.74032-0.65974-1.32413-1.44874-1.75142-2.3669
			c-0.42782-0.91766-0.64122-1.94423-0.64122-3.07873c0-0.78373,0.07261-1.50061,0.2188-2.1504
			c0.14571-0.64982,0.33852-1.26329,0.57891-1.84097c0.2394-0.57745,0.52101-1.12948,0.84431-1.65554
			c0.32282-0.52591,0.66132-1.06741,1.01653-1.62424l4.8471-7.48784h5.7238L38.06536,37.51595z M41.84983,44.26129
			c0-0.99015-0.32822-1.81004-0.98512-2.45971c-0.6569-0.64992-1.51694-0.9747-2.58006-0.9747
			c-1.06362,0-1.92363,0.32478-2.58005,0.9747c-0.6569,0.64967-0.9856,1.46956-0.9856,2.45971
			c0,0.99002,0.3287,1.81007,0.9856,2.45986c0.65642,0.64979,1.51643,0.97458,2.58005,0.97458
			c1.06312,0,1.92315-0.32478,2.58006-0.97458C41.5216,46.07135,41.84983,45.25131,41.84983,44.26129z"
                                                    />
                                                    <radialGradient
                                                        id="SVGID_5_"
                                                        cx="87.31152"
                                                        cy="166.24605"
                                                        r="10.50201"
                                                        gradientTransform="matrix(0.9322 0 0 0.9222 -25.03283 -112.67091)"
                                                        gradientUnits="userSpaceOnUse"
                                                    >
                                                        <stop
                                                            offset={0}
                                                            style={{ stopColor: "rgb(69, 148, 198)" }}
                                                        />
                                                        <stop
                                                            offset={1}
                                                            style={{ stopColor: "rgb(3, 113, 178)" }}
                                                        />
                                                    </radialGradient>
                                                    <path
                                                        className="st4"
                                                        d="M48.94728,35.35023c0-1.01027,0.19234-1.89236,0.57843-2.64557
			c0.38512-0.75268,0.91693-1.38174,1.59493-1.88743c0.67702-0.50521,1.46444-0.88174,2.36124-1.12923
			c0.89631-0.24752,1.85543-0.37138,2.87733-0.37138c1.02094,0,1.98055,0.12386,2.87688,0.37138
			c0.89631,0.24749,1.67832,0.62402,2.34554,1.12923c0.6672,0.50569,1.19901,1.13476,1.59493,1.88743
			c0.3964,0.75321,0.59461,1.6353,0.59461,2.64557c0,1.19654-0.32823,2.21749-0.98513,3.06328
			c-0.65642,0.84592-1.57922,1.44407-2.76796,1.79447v0.06181c1.33395,0.35103,2.35587,0.9855,3.06477,1.90303
			c0.70892,0.91816,1.06362,2.05756,1.06362,3.41896c0,1.05209-0.21439,1.9803-0.6412,2.78465
			c-0.42782,0.80457-1.00082,1.46981-1.72004,1.99587c-0.71922,0.52604-1.54833,0.92316-2.48634,1.19127
			c-0.93803,0.26774-1.91873,0.40218-2.93967,0.40218c-1.0219,0-2.00162-0.13443-2.93964-0.40218
			c-0.93851-0.26811-1.76762-0.66524-2.48634-1.19127c-0.71972-0.52605-1.29323-1.1913-1.72052-1.99587
			c-0.42732-0.80435-0.64123-1.73255-0.64123-2.78465c0-1.3614,0.35422-2.5008,1.06362-3.41896
			c0.70842-0.91753,1.73034-1.552,3.06477-1.90303v-0.06181c-1.18823-0.35041-2.11104-0.94855-2.76746-1.79447
			C49.27551,37.56772,48.94728,36.54677,48.94728,35.35023z M53.26308,44.942c0,0.76338,0.2811,1.41305,0.84431,1.9495
			c0.56271,0.53648,1.31332,0.80422,2.25183,0.80422c0.93853,0,1.68864-0.26774,2.25186-0.80422
			c0.5627-0.53646,0.84383-1.18613,0.84383-1.9495c0-0.7836-0.28113-1.44359-0.84383-1.98005
			c-0.56321-0.53648-1.31333-0.80457-2.25186-0.80457c-0.9385,0-1.68912,0.26809-2.25183,0.80457
			C53.54417,43.49841,53.26308,44.1584,53.26308,44.942z M53.63789,36.00002c0,0.68069,0.25021,1.25849,0.75059,1.73265
			c0.50092,0.47492,1.15734,0.71161,1.97073,0.71161c0.81294,0,1.46984-0.23669,1.96975-0.71161
			c0.50092-0.47416,0.75062-1.05196,0.75062-1.73265c0-0.65999-0.2497-1.22699-0.75062-1.70176
			c-0.49991-0.47416-1.15681-0.71161-1.96975-0.71161c-0.81339,0-1.46981,0.23745-1.97073,0.71161
			C53.8881,34.77303,53.63789,35.34003,53.63789,36.00002z"
                                                    />
                                                    <radialGradient
                                                        id="SVGID_6_"
                                                        cx="48.4652"
                                                        cy="166.24605"
                                                        r="10.52914"
                                                        gradientTransform="matrix(0.9322 0 0 0.9222 -25.03283 -112.67091)"
                                                        gradientUnits="userSpaceOnUse"
                                                    >
                                                        <stop
                                                            offset={0}
                                                            style={{ stopColor: "rgb(69, 148, 198)" }}
                                                        />
                                                        <stop
                                                            offset={1}
                                                            style={{ stopColor: "rgb(3, 113, 178)" }}
                                                        />
                                                    </radialGradient>
                                                    <path
                                                        className="st5"
                                                        d="M17.4733,29.61073c0.84798-0.18128,1.73572-0.29411,2.674-0.29411c0.97972,0,1.92338,0.11896,2.83026,0.35568
			c0.90711,0.2377,1.70457,0.60895,2.39239,1.11401c0.68805,0.50569,1.23556,1.14016,1.64202,1.90303
			c0.40644,0.76325,0.6098,1.67073,0.6098,2.7228c0,1.21742-0.32355,2.25871-0.96965,3.12513
			c-0.64612,0.86626-1.58463,1.42322-2.81456,1.67071v0.09286c0.6672,0.08266,1.25593,0.27839,1.76712,0.58785
			c0.51071,0.30944,0.94292,0.69136,1.29765,1.14493c0.3547,0.45391,0.62575,0.96978,0.81339,1.54697
			c0.18741,0.5778,0.28161,1.18637,0.28161,1.82552c0,1.09366-0.21414,2.05289-0.6412,2.87758
			c-0.42757,0.8252-1.00082,1.51128-1.72005,2.05756c-0.7197,0.54678-1.56401,0.9542-2.53343,1.22232
			c-0.96943,0.26774-1.99673,0.40218-3.08046,0.40218c-1.98103,0-3.6856-0.45357-5.11349-1.36153
			c-1.42812-0.90736-2.1547-2.34087-2.61316-4.3007l4.7242-1.14493c0.16681,0.7841,0.50531,1.403,1.01652,1.85654
			c0.51071,0.45392,1.26648,0.68059,2.26753,0.68059c1.02094,0,1.77719-0.26284,2.26755-0.789
			c0.48961-0.52581,0.73467-1.63113,0.73467-2.45642c0-0.61877-0.13074-1.09846-0.39077-1.43879
			c-0.26123-0.34036-0.59976-0.59277-1.01675-0.75798c-0.41727-0.16508-0.88628-0.26309-1.40729-0.29387
			c-0.52151-0.03104-1.04252-0.04649-1.56353-0.04649h-1.09502v-3.59241h1.53263c0.43762,0,0.86493-0.03115,1.28218-0.09296
			c0.41725-0.06194,0.79746-0.1803,1.14186-0.35606c0.3439-0.17477,0.61988-0.42252,0.82862-0.74238
			c0.208-0.31951,0.31275-0.73726,0.31275-1.25324c0-0.65971-0.26591-1.20649-0.79746-1.63994
			c-0.53181-0.43307-1.18356-0.64954-1.95478-0.64954c-0.72977,0-1.33467,0.19623-1.81399,0.58785
			c-0.47979,0.3921-0.79256,0.87706-0.93825,1.45436l-4.44284-1.26708C12.98335,34.36179,13.47003,30.46607,17.4733,29.61073z"
                                                    />
                                                </g>
                                            </g>
                                        </svg>
                                        <span>CMD Sports</span>
                                    </div>
                                </li>
                                <li
                                    className="tab-header false"
                                    data-provider-name="SBO2"
                                    data-provider-code="SBO2"
                                >
                                    <div className="tab-inner">
                                        <svg
                                            className="hf901OS489Bb325d0"
                                            version="1.1"
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 90 90"
                                            xmlSpace="preserve"
                                        >
                                            <title>SBO2</title>
                                            <style
                                                type="text/css"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        ".hf901OS489Bb325d0 .st1{fill:url(#SVGID_00000132774393696215997640000000358169190542434707_);} .hf901OS489Bb325d0 .st1{fill:url(#SVGID_00000132774393696215997640000000358169190542434707_);} .hf901OS489Bb325d0 .st15{fill:#FFFFFF;} .hf901OS489Bb325d0 .st18{fill:#002E6D;} "
                                                }}
                                            />
                                            <g>
                                                <path
                                                    className="st18"
                                                    d="M79.2947,28.2972c-0.00012-1.53472-1.81825-2.48139-3.2481-1.6911
		c-1.76608,0.97623-3.76241,1.57933-5.87567,1.74931c-3.67762,0.29884-7.25728-0.74273-10.08386-2.92472L40.6872,10.45231
		c-5.18056-4.00037-11.7447-5.90345-18.48114-5.36184c-1.74343,0.14042-3.43985,0.44922-5.07546,0.90613
		c-1.80915,0.50538-3.04454,2.04384-3.04454,3.78341l-0.00012,5.91285c0,1.53461,1.81789,2.48139,3.24773,1.69133
		c1.76583-0.97577,3.7618-1.57854,5.87494-1.74874c3.67873-0.29578,7.25678,0.74341,10.08373,2.92529l0.89005,0.68724
		L16.97023,38.12164c-1.52399,1.67117-1.2872,4.16275,0.52909,5.5651l10.81798,8.35201L11.2116,70.79577
		c-1.17201,1.28526-0.17895,3.24473,1.64436,3.24462l10.41455-0.00011l21.25443-23.30626L30.41849,39.84309l12.57667-13.79118
		l9.69741,7.48698c4.60176,3.55285,10.29369,5.45231,16.23041,5.45231c0.74667-0.00023,1.49802-0.03001,2.25048-0.09105
		c1.74405-0.1403,3.44083-0.4491,5.0767-0.90613c1.80915-0.5055,3.04454-2.04395,3.04454-3.78352V28.2972z"
                                                />
                                                <g>
                                                    <path
                                                        className="st15"
                                                        d="M18.88755,83.88657h8.42222c1.26716,0,2.46939-0.51582,3.28391-1.40897l27.38324-30.02667
			c1.52184-1.66875,1.28527-4.15667-0.52839-5.55691l-10.82252-8.35556l23.82457-26.12533
			c1.17028-1.2833,0.17867-3.23984-1.642-3.23983l-8.42192,0.00006c-1.26715,0.00001-2.46937,0.51583-3.28388,1.40897
			L30.41825,39.84298l14.10657,10.89115L17.2456,80.64672C16.07528,81.93001,17.06687,83.88657,18.88755,83.88657z"
                                                    />
                                                    <path
                                                        className="st18"
                                                        d="M27.30951,85H18.8873c-1.31736,0-2.48171-0.68269-3.03878-1.78119
			c-0.55707-1.09904-0.37689-2.35844,0.47023-3.28735L42.82063,50.8709L28.71371,39.97992L56.17613,9.86706
			c1.04679-1.14796,2.58154-1.80674,4.21081-1.80674h8.42162c1.31795,0,2.4823,0.68269,3.03937,1.78119
			c0.55708,1.09904,0.3763,2.35843-0.47023,3.28681L48.33048,38.40147l9.89553,7.63951
			c2.32162,1.79315,2.62526,4.98973,0.67758,7.12531L31.52032,83.19272C30.47412,84.34122,28.93937,85,27.30951,85z
			 M32.12229,39.70597l14.10693,10.89098L18.1725,81.36206c-0.34499,0.37885-0.20676,0.7664-0.13115,0.91587
			c0.07561,0.14893,0.30955,0.49571,0.84594,0.49571h8.42221c0.91211,0,1.77105-0.36852,2.35647-1.01154l27.38386-30.02643
			c1.09051-1.1958,0.92038-2.98569-0.37926-3.98907l-11.74868-9.0712l24.60205-26.9777
			c0.34499-0.37831,0.20676-0.76585,0.13114-0.91478c-0.07561-0.14947-0.30955-0.49625-0.84653-0.49625h-8.42162
			c-0.91211,0-1.77105,0.36852-2.35706,1.01099L32.12229,39.70597z"
                                                    />
                                                </g>
                                            </g>
                                        </svg>
                                        <span>Sbobet Sports</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="bottom-category">
                            <div className="bottom-content">
                                <div className="title">BK8 Sports</div>
                                <div className="subtitle">
                                    เว็บพนันกีฬาออนไลน์ที่มีชื่อเสียงที่สุดในเอเชีย
                                </div>
                                <div className="description">
                                    BK8 Sports เป็นเกมเดิมพันกีฬาที่พัฒนาและเปิดตัวโดย BK8
                                    ผู้พัฒนาการพนันกีฬาชั้นนำของตลาด BK8 มีพนักงานมืออาชีพมากกว่า 100
                                    คนและผู้เชี่ยวชาญด้านการบริการลูกค้าที่ปฏิบัติหน้าที่ 365 วันต่อปีตลอด
                                    24
                                    ชั่วโมงเพื่อให้ผู้เล่นทั่วโลกมีประสบการณ์การเดิมพันที่ดีที่สุดและประเภทกีฬาและกิจกรรมที่หลากหลายที่สุด
                                </div>
                                <button>เล่นตอนนี้</button>
                            </div>
                            <div className="bottom-content-img">
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet="https://baryon.million-edge.online/public/html/images/sports/BTI.webp"
                                    />
                                    <img
                                        src="https://baryon.million-edge.online/public/html/images/sports/BTI.jpg"
                                        alt=""
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>


            </>

        );
    }
}
export default App;
